<template>
  <el-dialog title="Edit Company Info" :close-on-click-modal="false" :visible.sync="visible" width="1100px" top="3vh">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-position="top">
      <el-row>
        <el-col :lg="18" :xl="15">
          <el-form-item label="Company Name (Option 1)" prop="proposedCompanyName1">
            <el-input
              v-model="dataForm.proposedCompanyName1"
              placeholder="Proposed Company Name (Option 1)"
              class="input-with-select-lg"
              v-regexFilter="halfWidthRegex"
            >
              <el-select v-model="dataForm.proposedCompanyType1" slot="append">
                <el-option v-for="item in companySuffixList" :key="`suffix01-${item}`" :label="item" :value="item"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="18" :xl="15">
          <el-form-item label="Company Name (Option 2)" prop="proposedCompanyName2">
            <el-input
              v-model="dataForm.proposedCompanyName2"
              placeholder="Proposed Company Name (Option 2)"
              class="input-with-select-lg"
              v-regexFilter="halfWidthRegex"
            >
              <el-select v-model="dataForm.proposedCompanyType2" slot="append">
                <el-option v-for="item in companySuffixList" :key="`suffix02-${item}`" :label="item" :value="item"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :lg="18" :xl="15">
          <el-form-item label="Company Name (Option 3)" prop="proposedCompanyName3">
            <el-input
              v-model="dataForm.proposedCompanyName3"
              placeholder="Proposed Company Name (Option 3)"
              class="input-with-select-lg"
              v-regexFilter="halfWidthRegex"
            >
              <el-select v-model="dataForm.proposedCompanyType3" slot="append">
                <el-option v-for="item in companySuffixList" :key="`suffix03-${item}`" :label="item" :value="item"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- MSIC Codes -->
      <el-col :span="24">
        <el-form-item label="MSIC Code(Maximum 3)" prop="msicCodes">
          <el-select v-model="dataForm.msicCodes" multiple :multiple-limit="3" filterable placeholder="Select" class="wdb100" popper-class="tradeWrap">
            <el-option v-for="(item, i) in msicOptions" :key="'msic-' + i" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <!-- Business Description -->
      <el-col :span="24">
        <el-form-item label="Business Description" prop="businessDescription">
          <el-input
            type="textarea"
            v-model="dataForm.businessDescription"
            placeholder="Please enter"
            class="wdb100"
            :rows="5"
            :autosize="{ minRows: 4 }"
            maxlength="78"
            show-word-limit
            resize="none"
            v-regexFilter="halfWidthRegex"
          ></el-input>
        </el-form-item>
      </el-col>
      <!-- Nominee Director Service -->
      <el-form-item label="Nominee Director Service" prop="hasNomineeDirector" v-if="isNeedNomineeDirector">
        <el-checkbox class="checkboxCustom" :true-label="1" :false-label="0" v-model="dataForm.hasNomineeDirector">
          We consent to appoint one Nominee Director recommended by Estar Business Advisory Sdn. Bhd. ("EStar"), and we understand that any legal impact caused by
          the Nominee Director's action has nothing to do with EStar.
        </el-checkbox>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" @click="dataFormSubmit()">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

// MSIC 多选代码的分隔符（ASCII Unit Separator）
const MSIC_SEP = "\x1F";

export default {
  props: {
    businessType: {
      type: String,
    },
    isNeedNomineeDirector: {
      type: Boolean,
    },
  },
  data() {
    return {
      visible: false,
      // 公司名称后缀列表（马来西亚固定为 Sdn. Bhd.，参考前台 intitle/malaysia）
      companySuffixList: ["Sdn. Bhd."],
      dataForm: {
        id: 0,
        proposedCompanyName1: "",
        proposedCompanyType1: "",
        proposedCompanyName2: "",
        proposedCompanyType2: "",
        proposedCompanyName3: "",
        proposedCompanyType3: "",
        msicCodes: [],
        businessDescription: "",
        hasNomineeDirector: null,
      },
      dataRule: {
        // proposedCompanyName1: [{ required: true, message: "Company Name is required", trigger: "submit" }],
      },
      submitControl: true,
    };
  },
  computed: {
    ...mapGetters("constant", ["byCountryFormatList", "getApplyStep"]),
    msicOptions() {
      return this.byCountryFormatList("tradeData", "Malaysia");
    },
  },
  methods: {
    ...mapActions("applyment", ["doSaveRevising"]),
    async init(data) {
      this.submitControl = true;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      const copy = JSON.parse(JSON.stringify(data));
      copy.msicCodes = copy.msicCodes ? copy.msicCodes.split(MSIC_SEP) : [];
      this.dataForm = copy;
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async valid => {
        if (valid && this.submitControl) {
          this.submitControl = false;
          const dataFormCopy = JSON.parse(JSON.stringify(this.dataForm));
          dataFormCopy.msicCodes = (this.dataForm.msicCodes || []).join(MSIC_SEP);
          this.doSaveRevising({
            ...dataFormCopy,
            procedure: {
              step: this.getApplyStep("companyName"),
            },
          })
            .then(() => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.submitControl = true;
                },
              });
            })
            .catch(msg => {
              this.submitControl = true;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.checkboxCustom {
  ::v-deep .el-checkbox__label {
    overflow-wrap: break-word !important;
    word-wrap: break-word !important;
    -ms-word-break: break-all !important;
    word-break: break-all !important;
    word-break: break-word !important;
    hyphens: auto !important;
    display: inline-grid;
    white-space: pre-line;
    line-height: 20px;
  }
}
</style>
